import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errText } from "../../../lib/api";

export const HolidaysTab = () => {
  const [holidays, setHolidays] = useState([]);
  const [hForm, setHForm] = useState({ date: "", name: "" });

  const load = () => api.get("/holidays").then((r) => setHolidays(r.data));
  useEffect(() => { load(); }, []);

  const addHoliday = async (e) => {
    e.preventDefault();
    try {
      await api.post("/holidays", hForm);
      toast.success("Holiday added");
      setHForm({ date: "", name: "" });
      load();
    } catch (err) { toast.error(errText(err)); }
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="bg-white border border-stone-200 rounded-lg divide-y divide-stone-100">
        {holidays.map((h) => (
          <div key={h.id} className="p-4 flex justify-between text-sm">
            <span className="font-semibold">{h.name}</span><span className="tabular-nums text-stone-500">{h.date}</span>
          </div>
        ))}
      </div>
      <form onSubmit={addHoliday} className="bg-white border border-stone-200 rounded-lg p-6 space-y-4 self-start">
        <h3 className="font-heading font-bold">Add holiday</h3>
        <input type="date" required value={hForm.date} onChange={(e) => setHForm({ ...hForm, date: e.target.value })} data-testid="holiday-date-input" className="w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
        <input placeholder="Holiday name" required value={hForm.name} onChange={(e) => setHForm({ ...hForm, name: e.target.value })} data-testid="holiday-name-input" className="w-full min-h-[44px] px-3 rounded-lg border border-stone-300" />
        <button type="submit" data-testid="add-holiday-button" className="tap-scale px-6 py-3 rounded-full bg-primary text-white font-bold text-sm hover:bg-[#A63F07] transition-colors duration-200">Add holiday</button>
      </form>
    </div>
  );
};
